<template>
  <img
    class="media"
    v-if="src && type == 'img'"
    ref="refRoot"
    :key="`img-${src}`"
    :src="src"
    :alt="media?.alt"
    :copyright="media?.copyright"
    @load="onLoaded"
    @error="onLoaded"
    v-bind="$attrs"
    v-editable="_blok"
  />
  <video
    class="media"
    v-if="src && type == 'video'"
    ref="refRoot"
    :src="src"
    :alt="media.alt"
    :copyright="media.copyright"
    @canplay="onLoaded"
    loop="false"
    autoplay="true"
    playsinline="true"
    muted="true"
    v-bind="$attrs"
    v-editable="_blok"
  />
</template>

<script setup lang="ts">
const props = defineProps({
  blok: {
    type: Object,
  },
  path: {},
})
const emits = defineEmits(["loaded"])

const { app, debug, browser } = useStores()

const env = useEnv()

const _blok = computed(() => {
  let blok = props.blok
  if (Array.isArray(props.blok)) blok = props.blok[0]
  return blok
})

const media = computed(() => {
  if (env.isMobile && _blok.value?.mobile?.filename) {
    return _blok.value?.mobile
  }

  if (_blok.value?.desktop) {
    return _blok.value?.desktop
  }

  return null
})

const filename = ref(null)
watch(
  () => [media.value, env.isMobile, props.path],
  () => {
    filename.value = props.path || media.value?.filename
  },
  { immediate: true }
)
// usePrint('filename', filename.value)

const ext = computed(() => {
  if (!filename.value) return null
  return filename.value.split(/[#?]/)[0].split(".").pop().trim()
})

const type = computed(() => {
  const videoExts = ["mp4", "webm", "m3u8", "mpd"]
  if (videoExts.indexOf(ext.value) >= 0) return "video"

  const imgExts = [
    "jpg",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "gif",
    "png",
    "webp",
    "tif",
    "tiff",
    "apng",
    "avif",
    "svg",
    "bmp",
    "ico",
  ]
  if (imgExts.indexOf(ext.value) >= 0) return "img"

  // const lottieExts = ['json', 'lottie'];
  // if (lottieExts.indexOf(ext.value) >= 0) return 'lottie';

  return null
})

const src = computed(() => {
  return filename.value
})

const shouldLoad = ref(null)

const refRoot = ref(null)

// ******************************************************************
// SIZE
// ******************************************************************

onMounted(async () => {
  shouldLoad.value = true

  await nextTick()

  switch (type.value) {
    case "img": {
      if (refRoot.value?.complete) {
        emits("loaded")
      }
      break
    }
    case "video": {
      ;(async () => {
        await nextTick()
        refRoot.value?.play()
      })()
      break
    }
    case "lottie": {
      break
    }
    default: {
      emits("loaded")
    }
  }
})

onBeforeUnmount(() => {
  switch (type.value) {
    case "img": {
      break
    }
    case "video": {
      break
    }
    case "lottie": {
      break
    }
  }
})

const loaded = ref(false)
const onLoaded = function () {
  loaded.value = true

  switch (type.value) {
    case "img": {
      break
    }
    case "video": {
      refRoot.value?.play()
      break
    }
    case "lottie": {
      break
    }
  }

  emits("loaded")
}
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";
</style>
